import { messaging } from './firebase-config';
import { getToken } from 'firebase/messaging';

export const requestForToken = async (): Promise<string | null> => {
  if (!messaging) {
    console.warn('Firebase Messaging not initialized or unsupported');
    return null;
  }

  const permission = await Notification.requestPermission();

  if (permission !== 'granted') {
    console.warn('Notification permission not granted:', permission);
    return null;
  }

  try {
    const currentToken = await getToken(messaging, {
      vapidKey: process.env.REACT_APP_FIREBASE_VAPID_KEY,
    });

    if (currentToken) {
      return currentToken;
    } else {
      console.warn('No registration token available.');
      return null;
    }
  } catch (err) {
    console.error('An error occurred while retrieving token.', err);
    return null;
  }
};